import React from 'react';

export const MemberIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18px"
    height="16px"
    viewBox="0 0 18 16"
    style={{
      fillRule: 'nonzero',
    }}
    {...props}
  >
    <g>
      <path d="M11.3392723,1.65337453 C10.9892943,1.65337453 10.6551668,1.72273111 10.3488047,1.84751299 C10.8949731,2.53063719 11.2226579,3.39942113 11.2226579,4.34432282 C11.2226579,5.28922451 10.8949461,6.15798118 10.3488047,6.84113265 C10.6551668,6.96591453 10.9892943,7.03527111 11.3392723,7.03527111 C12.8064141,7.03527111 14,5.82815572 14,4.34435008 C14,2.86054444 12.8064141,1.65337453 11.3392723,1.65337453 Z"/>
      <path d="M11.6405508,8.71306667 C11.5111055,8.71306667 11.3818711,8.71719111 11.252918,8.72519111 C13.1523047,10.2095289 14.3778867,12.5349333 14.3778867,15.1447467 C14.3778867,15.4388267 14.3272969,15.7210667 14.2352227,15.9836444 L17.1705234,15.9836444 C17.6286094,15.9836444 18,15.6080356 18,15.1447467 C18,11.5983289 15.1471406,8.71306667 11.6405508,8.71306667 Z"/>
      <path d="M9,1.25255111 C8.36300391,0.496924444 7.41592969,0.01632 6.35944922,0.01632 C4.44603516,0.01632 2.88938672,1.59061333 2.88938672,3.52579556 C2.88938672,5.46097778 4.446,7.03523556 6.35944922,7.03523556 C7.41596484,7.03523556 8.36300391,6.55466667 9,5.79900444 C9.51662109,5.18609778 9.82947656,4.39249778 9.82947656,3.52576 C9.82947656,2.65902222 9.51662109,1.86545778 9,1.25255111 Z"/>
      <path d="M8.99873438,9.29372444 C8.19435938,8.92113778 7.30054687,8.71306667 6.35944922,8.71306667 C2.85285937,8.71306667 0,11.5983289 0,15.1447467 C0,15.6080356 0.371390625,15.9836444 0.829476563,15.9836444 L11.8893867,15.9836444 L11.889457,15.9836444 C12.347543,15.9835733 12.7188984,15.6079644 12.7188984,15.1447467 C12.7188984,12.5500089 11.1916758,10.3095467 8.99873438,9.29372444 Z"/>
    </g>
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/member-icon.js